/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Auto_Embed_LabelInputs */



/**
* | output |
* | --- |
* | "Auto-Embed Files" |
*
* @param {Spaces_Auto_Embed_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_auto_embed_label = /** @type {((inputs?: Spaces_Auto_Embed_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Auto_Embed_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateien automatisch einbetten")
	return /** @type {LocalizedString} */ ("Auto-Embed Files")
});